import * as ActionTypes from "../Types/ActionTypes";

export const NpaMasters = (
  state = {
    isLoading: true,
    errMess: null,
    npaMasters: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_NPAMASTERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        npaMasters: action.payload,
      };

    case ActionTypes.NPAMASTERS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        npaMasters: [],
      };

    case ActionTypes.NPAMASTERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        npaMasters: [],
      };

    default:
      return state;
  }
};
